
let currentProduct;
let iframeSrc;
let iframeElement;
let customer = 'TWEEDCOASTGLASS';

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};

const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '').pop();
    const productParts = product.split('?');
    currentProduct = `${productParts[0]}`;
    console.log('Final SKU:', currentProduct.toLowerCase());
    return currentProduct.toLowerCase();
};

const insertMazingThumb = (thumbGallery, overlayImgSrc, index) => {
    const firstRealThumb = thumbGallery.querySelector('button.product-gallery--media-thumbnail img');
    if (!firstRealThumb) {
        console.warn('No reference thumbnail found.');
        return;
    }

    const backgroundSrc = firstRealThumb.getAttribute('src');
    const backgroundSrcSet = firstRealThumb.getAttribute('srcset') || '';
    const backgroundAlt = firstRealThumb.getAttribute('alt') || '';

    const button = document.createElement('button');
    button.id = 'mazing-thumb';
    button.type = 'button';
    button.className = 'product-gallery--media-thumbnail product-gallery--image-thumbnail';
    button.setAttribute('data-gallery-thumbnail', '');
    button.setAttribute('data-gallery-selected', 'false');
    button.setAttribute('data-media', 'mazing-thumb');
    button.setAttribute('data-media-type', 'image');
    button.setAttribute('data-media-id', 'mazing-media-id');
    button.setAttribute('data-gallery-index', index);
    button.setAttribute('aria-label', '3D View');
    button.setAttribute('tab-index', '0');

    const span = document.createElement('span');
    span.className = 'product-gallery--media-thumbnail-img-wrapper';
    span.setAttribute('tabindex', '-1');
    span.style.position = 'relative';

    const backgroundImg = document.createElement('img');
    backgroundImg.src = backgroundSrc;
    backgroundImg.srcset = backgroundSrcSet;
    backgroundImg.alt = backgroundAlt;
    backgroundImg.className = 'product-gallery--media-thumbnail-img';
    backgroundImg.style.opacity = '0.5';

    const overlayImg = document.createElement('img');
    overlayImg.src = overlayImgSrc;
    overlayImg.alt = '3D Overlay';
    overlayImg.style.position = 'absolute';
    overlayImg.style.top = '50%';
    overlayImg.style.left = '50%';
    overlayImg.style.transform = 'translate(-50%, -50%)';
    overlayImg.style.width = '80%';
    overlayImg.style.height = '80%';
    overlayImg.style.objectFit = 'contain';
    overlayImg.style.opacity = '0.9';
    overlayImg.style.pointerEvents = 'none';
    overlayImg.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';

    span.appendChild(backgroundImg);
    span.appendChild(overlayImg);
    button.appendChild(span);

    const target = thumbGallery.children[index] || null;
    thumbGallery.insertBefore(button, target);
};

const insertMazingFigure = (imgGallery, iframeSrc, index) => {
    const figure = document.createElement('figure');
    figure.id = 'mazing-figure';
    figure.className = 'product-gallery--media product-gallery--image';
    figure.setAttribute('data-gallery-selected', 'false');
    figure.setAttribute('aria-hidden', 'true');
    figure.setAttribute('data-media', 'mazing-iframe');
    figure.setAttribute('data-media-id', 'mazing-media-id');
    figure.setAttribute('data-media-type', 'iframe');
    figure.setAttribute('data-gallery-index', index);
    figure.setAttribute('role', 'group');

    figure.style.height = '100%';

    iframeElement = document.createElement('iframe');
    iframeElement.src = iframeSrc;
    iframeElement.width = '100%';
    iframeElement.height = '100%';
    iframeElement.style.border = 'none';
    iframeElement.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;";

    figure.appendChild(iframeElement);

    const target = imgGallery.children[index] || null;
    imgGallery.insertBefore(figure, target);
};

const setupThumbClickListeners = (thumbGallery, imgGallery) => {
    const mazingThumb = thumbGallery.querySelector('#mazing-thumb');
    const iframeItem = imgGallery.querySelector('#mazing-figure');

    if (!mazingThumb || !iframeItem) return;

    mazingThumb.setAttribute('data-gallery-index', '-1');
    iframeItem.setAttribute('data-gallery-index', '-1');

    mazingThumb.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        thumbGallery.querySelectorAll('[data-gallery-selected]').forEach(el =>
            el.setAttribute('data-gallery-selected', 'false')
        );

        imgGallery.querySelectorAll('[data-gallery-selected]').forEach(el => {
            el.setAttribute('data-gallery-selected', 'false');
            el.setAttribute('aria-hidden', 'true');
        });

        mazingThumb.setAttribute('data-gallery-selected', 'true');
        iframeItem.setAttribute('data-gallery-selected', 'true');
        iframeItem.setAttribute('aria-hidden', 'false');
    });

    Array.from(thumbGallery.children).forEach((thumb) => {
        if (thumb !== mazingThumb) {
            thumb.addEventListener('click', () => {
                mazingThumb.setAttribute('data-gallery-selected', 'false');
                iframeItem.setAttribute('data-gallery-selected', 'false');
                iframeItem.setAttribute('aria-hidden', 'true');
            });
        }
    });
};

const observeMazingFigure = () => {
    const iframeItem = document.querySelector('#mazing-figure');
    const expandBtn = document.querySelector('.product-gallery--expand');

    if (!iframeItem || !expandBtn) return;

    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (
                mutation.type === 'attributes' &&
                mutation.attributeName === 'data-gallery-selected'
            ) {
                const isSelected = iframeItem.getAttribute('data-gallery-selected') === 'true';
                expandBtn.style.display = isSelected ? 'none' : '';
            }
        }
    });

    observer.observe(iframeItem, { attributes: true });
};

const toggleGallerySwipe = (disable) => {
    const container = document.querySelector('.product-gallery--viewer');
    if (!container) return;

    container.style.overflowX = disable ? 'hidden' : '';
    container.style.touchAction = disable ? 'none' : '';
};

const setupVariantChangeListener = () => {
    const variantSelect = document.querySelector('select[name="id"]');
    const colourSelect = document.querySelector('select[data-product-option="0"]');

    if (!variantSelect) {
        console.warn('Main variant select not found.');
        return;
    }

    variantSelect.addEventListener('change', () => {
        const colourValue = (colourSelect?.value?.trim().toLowerCase().replace(/\s+/g, '-')) || '';

        if (iframeElement) {
            iframeElement.contentWindow.postMessage({
                type: 'SWITCH_VARIANT',
                value: {
                    trigger: colourValue,
                }
            }, '*');

            console.log('Posted message to iframe:', {
                trigger: colourValue
            });
        } else {
            console.warn('Iframe not found to post message.');
        }
    });
};


const initializeMazing = async () => {
    const imgGallery = await waitForElement('.product-gallery--viewer');
    const thumbGallery = await waitForElement('.gallery-navigation--scroller');

    const myImageSrc = 'https://cdn.mazing.link/assets/svg/3D.svg';

    iframeSrc = await mazingProjectAvailable({
        customerName: customer,
        getSKU: getCurrentSKU,
    });

    if (!iframeSrc) {
        console.log('iframeSrc not found, aborting script execution.');
        return;
    }

    const insertIndex = 1;

    insertMazingFigure(imgGallery, iframeSrc, insertIndex);
    insertMazingThumb(thumbGallery, myImageSrc, insertIndex);
    setupThumbClickListeners(thumbGallery, imgGallery);

    observeMazingFigure();
    setupVariantChangeListener()
    toggleGallerySwipe(true);
    console.log('Mazing initialized with synced indices.');
};

const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        await waitForElement('.product-form--atc-button');

        mazingSetAB({
            enabled: true,
            addToCartListeners: (callback) => {

                document.querySelector('.product-form--atc-button').addEventListener('click', () => {
                    console.log('MAZING: addToCartClicked A/B');
                    callback();
                });

                return true;
            }
        });

        await initializeMazing();
        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};

initializeScript();